const preferences = {
  savePreference() {
    return `/preference/save`;
  },
  loadPreference(code) {
    return `/preference/load/${code}`;
  },
  loadUserPreferences() {
    return `/preference/load-multiple`;
  }
};

export default preferences;